export default __webpack_public_path__ + "static/media/p-5.194db7b2.png";